






















import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NavBar, Row, Icon, NoticeBar } from "vant";
import WeMixin from "@/components/weMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
  },
})
export default class ErrorPage extends mixins(WeMixin) {
  @Prop({ default: "404" })
  private message!: string;
  @Prop({ default: "认证页面出错了" })
  private title!: string;
  private tips!: string;
  private msgShow!: any;

  protected created() {
    this.tips = this.$route.query.tips as string;
  }

  get msg() {
    if (this.$route.query.message) {
      this.msgShow = this.$route.query.message as any;
      // console.log(this.msgShow)
      return this.parseErrorMsg(this.msgShow.trace);
    } else {
      return this.parseErrorMsg(this.msgShow.trace);
    }
  }

  protected parseErrorMsg(errMsg: string) {
    // debugger
    const regExp = /(\u9519\u8bef).*?(?=#)/g;
    // console.log(errMsg.match(regExp))
    const res = errMsg.match(regExp) as any;
    return res[0];
  }
}
